<template>
  <div class="d-flex flex-grow-1 mh-0 flex-column" ref="fdScroll">
    <!-- OverlayScrollbars NEEDS an child intermediate content wrapper -->
    <!-- <div class="os-viewport"> will be inserted by the module -->
    <div class="d-flex flex-grow-1 flex-column">
      <slot/>
    </div>
    <!-- </div> will be inserted by the module -->
  </div>
</template>

<script>
import {OverlayScrollbars} from "@/../node_modules/overlayscrollbars";

export default {
  name: "FdScroll",

  components: {},

  props: {
    x: Boolean,
    y: Boolean,
  },

  data() {
    return {
      id: undefined,
      instance: undefined,
    };
  },

  computed: {},

  watch: {},

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
  },

  mounted() {
    this.instance = OverlayScrollbars(this.$refs.fdScroll, {
      className: "os-theme-dark os-scrollbar-track",
      overflow: {
        x: this.x ? "scroll" : "hidden",
        y: this.y ? "scroll" : "hidden",
      },
    });
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {},
};
</script>

<style lang="scss">
@import "@/sass/settings/colors";

/* =========================================================================
 * LEVEL BAR
 * ========================================================================= */

.os-viewport {
  display: flex;
  flex-grow: 1;
  min-height: 0;
  flex-direction: column;
}

.os-scrollbar {
  padding: 0 !important;
  background-color: $gmb-color-white !important;

  &:hover {
    cursor: pointer !important;
  }
}

.os-scrollbar-horizontal {
  height: 1px !important;
}

.os-scrollbar-vertical {
  width: 1px !important;
}

.os-scrollbar-auto-hidden {
}

.os-scrollbar-auto-hidden {
}

.os-scrollbar-unusable {
}

.os-scrollbar-track {
}

.os-scrollbar-track-off {
}

.os-scrollbar-handle {
  border-radius: unset !important;
  background-color: $gmb-color-theme-3 !important;
}

.os-scrollbar-handle-off {
}
</style>
